export class UnlinkAccessRequest {
    body = {
        ProcessName: 'DC Community Portal SR Process Wrapper WF',
        DCMethod: 'APPROVE',
        DCLanguage: 'ENU',
        DCLoginName: '', // fill dynamically
        DCIncomingHierarchy: {
            MessageId: '',
            IntObjectName: 'DC Community Portal SR Upsert IO',
            MessageType: 'Integration Object',
            IntObjectFormat: 'Siebel Hierarchical',
            "ListOfDC Community Portal SR Upsert IO": {
                "DC Community Portal SR": {
                    "CSN": '',
                    "DC Channel": 'Online',
                    "SR Type": 'User Management',
                    "Sub Type": 'Unlink Access',
                    "DC Delink User ID": ''
                }
            }
        }
    };
}
